import { type Observable, tap, switchMap, map, catchError, of } from 'rxjs';
import { appConfigDetail } from 'services/api/application-config/app-config';
import filterWhileNullish from 'utils/rxjs/filter-while-nullish';
import progressiveRetry from 'utils/rxjs/progressive-retry';

import Store from './store';
import notifyUserOnError from './utils/notify-user-on-error';

interface ApplicationConfigStore {
  csc: {
    url: string;
  };
}

class ApplicationConfig extends Store<ApplicationConfigStore | undefined> {
  source$ = of(true).pipe(
    tap(() => super.meta.setLoading(true)),
    switchMap(() => appConfigDetail('web')),
    progressiveRetry(),
    notifyUserOnError({ type: 'error', message: 'request-failed', onClick: () => this.reset() }),
    map((response) => response.data.data),
    map((data) => ({
      csc: {
        url: data.common.csc.url,
      },
    })),
    catchError(() => {
      return of(undefined);
    })
  );

  constructor() {
    super({
      name: 'application-config',
      initialState: undefined,
    });
  }

  get onChange$(): Observable<ApplicationConfigStore | undefined> {
    return super.onChange$.pipe(filterWhileNullish());
  }
}

export type { ApplicationConfigStore };
export default new ApplicationConfig();
